export default __webpack_public_path__ + "static/video_poster_laptop_image-c6c2bf75c812b94613abbfa8dc9c63c9.jpg";